"use strict";
function reg(fname, lname, addr1, addr2, addr3, cty, stte, cntry, pcode, eml, sno, unme, pwd, purl) {
  $.ajax({
    type: "POST",
    url: purl,
    crossDomain: true,
    dataType: "json",
    data: {
      FirstName: fname, 
      LastName: lname, 
      Address1: addr1, 
      Address2: addr2, 
      Address3: addr3, 
      City: cty, 
      State: stte, 
      Country: cntry,           
      PostalCode: pcode, 
      Email: eml, 
      SerialNumber: sno,           
      Username: unme, 
      Password: pwd		
    },
    contentType: "application/x-www-form-urlencoded",
    success: function(data) {
      var returnval = JSON.stringify(data);
      var preturnval = JSON.parse(returnval);
      if (preturnval.responseText) {
        if (preturnval.responseText.substring(0, 7) === "Error -") {
          alert(preturnval.responseText);
        } else {
          alert("OK");
        }
      }            
    }
  });
}


function subup(sn, cd, purl) {
  var retVal = "";
  
  $.ajax({
    type: "POST",
    url: purl,
    crossDomain: true,
    dataType: "json",
    data: {
      SerialNumber: sn,
      DBSubscriptionCode: cd
    },
    contentType: "application/x-www-form-urlencoded"
  })
  .always(function (data) {
    var returnval = JSON.stringify(data);
    var preturnval = JSON.parse(returnval);
    if (preturnval.responseText) {
      if (preturnval.responseText.substring(0, 7) === "Error -") {
        retVal = preturnval.responseText.toString();
      } else {
        retVal = "OK";
      }
    }
    return retVal;
  });
}


function recover (un, purl) {
  $.ajax({
    type: "POST",
    url: purl,
    crossDomain: true,
    dataType: "json",
    data: {
      Username: un
    },
    contentType: "application/x-www-form-urlencoded"
  })
  .always(function(data) {
    var returnval = JSON.stringify(data);
    var preturnval = JSON.parse(returnval);
    if (preturnval.responseText) {
      if (preturnval.responseText.substring(0,7) === "Error -") {
        return preturnval.responseText;
      } else {
        return "OK";
      }
    }
  });
}


function uppw (un, cpw, npw, purl) {
  $.ajax({
    type: "POST",
    url: purl,
    crossDomain: true,
    dataType: "json",
    data: {
      username: un,
      pw: cpw,
      newpw: npw
    },
    contentType: "application/x-www-form-urlencoded"
  })
  .always(function(data) {
    alert('calling update pw');
    var returnval = JSON.stringify(data);
    var preturnval = JSON.parse(returnval);
    if (preturnval.responseText) {
      alert(preturnval.responseText);
      if (preturnval.responseText.substring(0,7) === "Error -") {
        return preturnval.responseText;
      } else {
        return "OK";
      }
    }
  });
}